import { Injectable } from '@angular/core';
import {  MailMessage } from '../_types/mail-message';
import { Service } from 'src/app/core/jsonapi/service';
import { prop } from '@rxweb/reactive-form-validators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MailMessageService extends Service<MailMessage> {
  public override type = 'mailMessages';
  public override url = 'communications/mailMessages';
  

  public Save(mailMessage: any): Observable<void> {
    let url = this.getAPIUrl()+ '/Save';    
    return this.http.post<void>(url, mailMessage);
  }

  public MailMessageSend(mailMessage: any): Observable<any> {
    let url = this.getAPIUrl()+ '/MailMessageSend';    
    return this.http.post<any>(url, mailMessage);
  }
}
